













































import { Component, Vue } from "vue-property-decorator";

@Component
export default class TipBlock extends Vue {
  currentBlock = "welcome";
  blocks: Map<string, number> = new Map([
    ["midi", 10],
    ["size", 10],
    ["pckeyboard", 10]
  ]);

  selectRandomBlock() {
    let weightSum = 0;
    this.blocks.forEach(value => {
      weightSum += value;
    });

    let newBlock = "size";
    let runningWeightSum = 0;
    const randomWeight = Math.random() * weightSum;
    this.blocks.forEach((value, block) => {
      if (runningWeightSum <= randomWeight && block !== this.currentBlock) {
        newBlock = block;
      }
      runningWeightSum += value;
    });

    this.currentBlock = newBlock;
  }
}
